import { render, staticRenderFns } from "./b-setting-dd.vue?vue&type=template&id=f117208e&scoped=true&"
import script from "./b-setting-dd.vue?vue&type=script&lang=ts&"
export * from "./b-setting-dd.vue?vue&type=script&lang=ts&"
import style0 from "./b-setting-dd.vue?vue&type=style&index=0&id=f117208e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f117208e",
  null
  
)

export default component.exports